import { useNavigate } from "react-router-dom";
import { Button } from "@/components";
import { useTranslate } from "@/providers/context";

export const ResetPasswordError = () => {
  const navigate = useNavigate();
  const { translate } = useTranslate();
  return (
    <div className="text-item-primary flex flex-col">
      <div className="h1">{translate("Your email has expired")}</div>
      <div className="p1-regular sm:h5-regular mb-7 pt-3">
        {translate(
          "The email link you were sent to reset your password has expired. Return to sign in to try again.",
        )}
      </div>
      <div className="bg-surface-primary border-border fixed bottom-0 left-0 right-0 flex flex-col items-center border-t px-5 py-4 sm:relative sm:border-none sm:p-0">
        <Button
          className="text-md h-fit w-full max-w-[440px] px-[14px] py-[10px] sm:mt-[8px] sm:text-sm"
          onClick={() => navigate("/sign-in")}
        >
          {translate("Return To Sign In")}
        </Button>
      </div>
    </div>
  );
};
